import { IconChevronDropdownDown } from '@doltech/icons/IconChevronDropdownDown';
import { Dropdown, Menu } from 'antd';
import cl from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { useDeviceDetect } from '../../../../../../hooks/useDeviceQuery.hook';
import { colorsV2 } from '../../../../../colors-v2';
import { Typography } from '../../../../../DesignSystemV2/Typography';
import { useExerciseGapFillWithHintDoTestStore } from '../../store/exercise-gap-fill-with-hint-do-test.store';

const InlineDropdownMain = styled.span`
  cursor: pointer;
  border-bottom: 1px solid ${colorsV2.gray40};
  &&& {
    .text {
      font-size: inherit;
      line-height: inherit;
      min-width: 60px;
      display: inline-block;
    }
  }
  .icon {
    font-size: 24px;
    position: relative;
    top: -3px;
  }

  &.have-value {
    &&& {
      .text {
        color: ${colorsV2.blue100};
        font-weight: 600;
      }
    }
    border-bottom: 1px solid ${colorsV2.blue100};
  }
`;

const MenuStyled = styled(Menu)`
  width: max-content;
`;

const MenuItemStyled = styled(Menu.Item)`
  font-size: 20px;
  line-height: 28px;
  padding: 12px 20px;
`;

interface InlineDropdownProps extends React.HTMLAttributes<HTMLDivElement> {
  value: any;
  options: any;
  blankId: string;
}

export const InlineDropdownBlank = ({
  value,
  options,
  className,
  ...rest
}: Omit<InlineDropdownProps, 'blankId'>) => {
  const currentValueExisted = options?.find((o) => o.id === value);
  const currentValueDisplayName = currentValueExisted?.displayName;
  return (
    <InlineDropdownMain
      className={cl(className, {
        'have-value': Boolean(currentValueExisted),
      })}
      {...rest}
    >
      <Typography.Text className={cl('text')}>{currentValueDisplayName || ' '}</Typography.Text>
      <IconChevronDropdownDown className="icon" />
    </InlineDropdownMain>
  );
};

export const InlineDropdownDesktop = (props) => {
  const { onChange, options, ...rest } = props;
  const renderMenu = React.useCallback(() => {
    return (
      <MenuStyled
        onClick={(info) => {
          onChange(info.key);
        }}
      >
        {options.map((option) => {
          const { displayName } = option;
          return <MenuItemStyled key={option.id}>{displayName}</MenuItemStyled>;
        })}
      </MenuStyled>
    );
  }, [onChange, options]);

  return (
    <Dropdown trigger={['click']} overlay={renderMenu}>
      <InlineDropdownBlank options={options} {...rest} />
    </Dropdown>
  );
};

export const InlineDropdownMobile = observer((props: InlineDropdownProps) => {
  const { blankId, ...rest } = props;
  const store = useExerciseGapFillWithHintDoTestStore();

  return (
    <InlineDropdownBlank
      onClick={() => {
        store.toggleDrawer(true);
        store.setCurrentBlank(blankId);
      }}
      {...rest}
    />
  );
});

export const GapFillInlineDropdown = observer((props: InlineDropdownProps) => {
  const { isDesktop } = useDeviceDetect();
  if (isDesktop) {
    return <InlineDropdownDesktop {...props} />;
  }
  return <InlineDropdownMobile {...props} />;
});
